import { ArrowRight, Phone, Users, Building2 } from "lucide-react";

const scrollTo = (id) => {
  const el = document.querySelector(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const pathways = [
  {
    icon: Users,
    label: "For Participants & Families",
    body: "Looking for community nursing support? Contact Everwell to discuss your needs, funding arrangement and preferred service schedule.",
    ctaLabel: "Request Community Nursing Support",
    testid: "cta-participant",
  },
  {
    icon: Building2,
    label: "For Providers & Healthcare Partners",
    body: "Need additional community nursing capacity? Contact Everwell to discuss subcontracting, brokerage, post-discharge nursing or ongoing clinical support.",
    ctaLabel: "Discuss Subcontracting",
    testid: "cta-provider",
  },
];

export const Referral = () => {
  return (
    <section
      id="referrals"
      data-testid="referrals-section"
      className="relative py-20 sm:py-28"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
        <div
          className="relative rounded-[32px] overflow-hidden p-8 sm:p-12 lg:p-16"
          style={{
            background:
              "linear-gradient(135deg, #2E5041 0%, #3f6a58 50%, #6E9C88 100%)",
          }}
        >
          <div
            aria-hidden
            className="absolute -top-10 -right-10 h-64 w-64 rounded-full bg-[var(--ew-blue)]/25 blur-3xl"
          />
          <div
            aria-hidden
            className="absolute -bottom-16 -left-10 h-64 w-64 rounded-full bg-white/10 blur-3xl"
          />

          <div className="relative">
            <div className="max-w-3xl">
              <p className="text-xs tracking-[0.18em] uppercase font-semibold text-[var(--ew-blue)]">
                Referrals & Subcontracting
              </p>
              <h2 className="font-heading font-medium mt-3 text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.08] text-white">
                Two clear pathways. One responsive team.
              </h2>
              <p className="mt-5 text-base sm:text-lg text-white/85 leading-relaxed">
                Whether you&apos;re seeking care for yourself or a family member, or
                you&apos;re an organisation looking for reliable community nursing
                capacity, we&apos;re happy to have a conversation.
              </p>
            </div>

            <div className="mt-10 grid md:grid-cols-2 gap-5">
              {pathways.map((p) => (
                <div
                  key={p.label}
                  data-testid={p.testid}
                  className="rounded-3xl bg-white/95 backdrop-blur border border-white/40 p-7 sm:p-8 shadow-[0_24px_60px_rgba(0,0,0,0.15)]"
                >
                  <div className="flex items-center gap-3">
                    <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[var(--ew-accent)] text-white">
                      <p.icon className="h-5 w-5" strokeWidth={1.75} />
                    </span>
                    <p className="font-heading text-lg font-semibold text-[var(--ew-text)]">
                      {p.label}
                    </p>
                  </div>
                  <p className="mt-4 text-[var(--ew-text-2)] leading-relaxed text-sm sm:text-base">
                    {p.body}
                  </p>
                  <div className="mt-6 flex flex-col gap-3">
                    <button
                      onClick={() => scrollTo("#contact")}
                      className="btn-primary w-full"
                    >
                      {p.ctaLabel}{" "}
                      <ArrowRight className="h-4 w-4" strokeWidth={2} />
                    </button>
                    <a
                      href="tel:0450270547"
                      className="btn-secondary w-full text-sm whitespace-nowrap px-4"
                    >
                      <Phone className="h-4 w-4" strokeWidth={1.75} />
                      Call 0450 270 547
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Referral;
